import React from 'react'
import {Table} from 'react-bootstrap'
function DashboardTable(props) {
    return (
        <div className="dashboard-table-block">
            <Table striped bordered hover>
  <thead>
    <tr>
      <th></th>
      <th># of orders</th>
      <th># of customers</th>
      <th>% of customers</th>
      <th>Avg. basket</th>
      <th>Total sales</th>
      <th>% Total orders</th>
      <th>ACV </th>
    </tr>
  </thead>
  <tbody>
    <tr>
    <td>New</td>
    <td>0</td>
      <td>0</td>
      <td>0%</td>
      <td>AED 0.00</td>
      <td>AED 0.00</td>
      <td>0%</td>
      <td>AED 0.00</td>
    </tr>
    <tr>
    <td>Returning</td>
    <td>0</td>
      <td>0</td>
      <td>0%</td>
      <td>AED 0.00</td>
      <td>AED 0.00</td>
      <td>0%</td>
      <td>AED 0.00</td>
    </tr>
    <tr>
    <td><b>Total</b></td>
    <td>0</td>
      <td>0</td>
      <td>0%</td>
      <td>AED 0.00</td>
      <td>AED 0.00</td>
      <td>0%</td>
      <td>AED 0.00</td>
    </tr>
  </tbody>
</Table>
        </div>
    )
}

export default DashboardTable
